import React, { useEffect, useState } from 'react';
import {
    NavLink, Navigate, Route, Routes as Switch, useNavigate,
} from 'react-router-dom';
import { delete_cookie } from 'sfcookies';
import TopBar from '../../../components/Topbar';
import Dashboard from '../../csv-tool/dashboard/Dashboard';
import Users from '../../users/Users';
import TemplateList from '../../csv-tool/templates/TemplateList';
import RequestedTemplateList from '../../csv-tool/templates/RequestedTemplateList';
import ImportList from '../../csv-tool/csvImport/ImportList';
import Report from '../../csv-tool/csvImport/Report';
import TemplateTypeList from '../../csv-tool/templateType/TemplateTypeList';
import TemplateTypeDetails from '../../csv-tool/templateType/TemplateTypeDetails';
import NetworkList from '../../csv-tool/network/NetworkList';
import Subscribers from '../../subscribers';
import IbvAccountVerification from '../../ibv-account-verification';
import Appointments from '../../appointments';
import Tools from '../../tools';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCsv, faRightFromBracket, faToolbox, faSubscript, faTableList, faUsersGear, faUsersViewfinder, faUserClock, faRectangleList, faFlagCheckered, faBell } from '@fortawesome/free-solid-svg-icons';
import { ADMIN_USERS, CSV_TOOL, SUBSCRIBERS, IBV_ACCOUNT_VERIFICATION, TOOLS, APPOINTMENT, SUBSCRIPTIONS, SUBSCRIBERSCALENDLY, ROLE_ADMIN, NOTIFICATION_TRACKER } from '../../../../utiles/constants';
import useUtils from '../../../../utiles/useUtiles';
import { UserDetailsI } from '../../../../utiles/interfaces'
import TopbarAdmin from './TopbarAdmin';
import TopbarSubscribers from '../../subscribers/TopbarSubscribers';
import TopbarAppointments from '../../appointments/TopbarAppointments';
import TopbarIbvAccountVerification from '../../ibv-account-verification/TopbarIbvAccountVerification';
import TopbarTools from '../../tools/TopbarTools';
import Subscriptions from '../../subscriptions';
import TopbarSubscribersCalendly from '../../virtual_assistans/TopbarSubscribersCalendly';
import SubscribersCalendly from '../../virtual_assistans';
import NotificationTracker from '../../notification_tracker';
import ConvertPdfToCsv from '../../tools/ConvertPdfToCsv';

const AdminUI: React.FC = () => {

    const { user } = useUtils();

    const userDetails: UserDetailsI | null = user();
    const navigate = useNavigate();

    const [state, setState] = useState<any>({
        selectedSection: document.location.pathname.split("/")[1],
    });

    const logOut = () => {
        delete_cookie('admin_pppcalc');
        window.history.replaceState('', '', '/');
        window.location.reload();
    };


    useEffect(() => {
        setState({ selectedSection: document.location.pathname.split("/")[1] });
    }, [document.location.pathname]);

    const gotTo = (section: string) => () => navigate(section);

    const userRole = parseInt(userDetails?.role || '0');

    return (
        <>
            <div className="mainContainer d-flex">
                <div className="sideBar">
                    <div className='d-flex justify-content-center'>
                        <NavLink className="navbar-brand" to="/">
                            <img src="logo-final-white.png" width={168} />
                        </NavLink>
                    </div>
                    <div className="menuOptions d-flex flex-column justify-content-between ">
                        <div>
                            <ul>
                                {
                                    userRole === ROLE_ADMIN && (
                                        <>
                                            <li onClick={gotTo(CSV_TOOL)} className={state.selectedSection === CSV_TOOL ? 'sidebarSelectedSection' : ""}>
                                                <FontAwesomeIcon icon={faFileCsv} className='pr-2' />
                                                CSV Tool
                                            </li>
                                            <li onClick={gotTo(ADMIN_USERS)}>
                                                <FontAwesomeIcon icon={faUsersViewfinder} className='pr-2' />
                                                Admin & VA
                                            </li>
                                            <li onClick={gotTo(SUBSCRIBERS)}>
                                                <FontAwesomeIcon icon={faUsersGear} className='pr-2' />
                                                Subscriber
                                            </li>
                                            <li onClick={gotTo(NOTIFICATION_TRACKER)}>
                                                <FontAwesomeIcon icon={faBell} className='pr-2' />
                                                Notification Tracker
                                            </li>
                                            <li onClick={gotTo(IBV_ACCOUNT_VERIFICATION)}>
                                                <FontAwesomeIcon icon={faUsersGear} className='pr-2' />
                                                IBV Account Verification
                                            </li>
                                            <li onClick={gotTo(APPOINTMENT)}>
                                                <FontAwesomeIcon icon={faUserClock} className='pr-2' />
                                                Scheduled Appointments
                                            </li>
                                            <li onClick={gotTo(TOOLS)}>
                                                <FontAwesomeIcon icon={faToolbox} className='pr-2' />
                                                Tools
                                            </li>
                                            <li onClick={gotTo(SUBSCRIPTIONS)}>
                                                <FontAwesomeIcon icon={faTableList} className='pr-2' />
                                                Subscriptions
                                            </li>
                                        </>
                                    )
                                }
                                <li onClick={gotTo(SUBSCRIBERSCALENDLY)}>
                                    <FontAwesomeIcon icon={faRectangleList} className='pr-2' />
                                    Subscribers Calendly
                                </li>

                            </ul>
                        </div>
                        <div className='text-center mb-2'>
                            Welcome {userDetails?.name} <div onClick={logOut} className='likeLink'>
                                <FontAwesomeIcon icon={faRightFromBracket} className='pr-2' />
                                logout
                            </div>
                        </div>
                    </div>
                </div>
                <div className="innerContent">
                    {state.selectedSection === CSV_TOOL && <TopBar />}
                    {state.selectedSection === ADMIN_USERS && <TopbarAdmin />}
                    {state.selectedSection === SUBSCRIBERS && <TopbarSubscribers />}
                    {state.selectedSection === IBV_ACCOUNT_VERIFICATION && <TopbarIbvAccountVerification />}
                    {state.selectedSection === TOOLS && <TopbarTools />}
                    {state.selectedSection === APPOINTMENT && <TopbarAppointments />}
                    {/* {state.selectedSection === SUBSCRIBERSCALENDLY && <TopbarSubscribersCalendly />} */}
                    {/* {state.selectedSection === SUBSCRIPTIONS &&  <SubscriptionsToolbar /> } */}
                    <Switch>
                        {/* CSV TOOL ROUTES */}
                        {
                            userRole === ROLE_ADMIN ?
                                <>
                                    <Route path="/" element={<Navigate to="/csv-tool/dashboard" />} />
                                    <Route path="/" element={<Navigate to="/csv-tool/dashboard" />} />
                                    <Route path="/csv-tool/dashboard" element={<Dashboard />} />
                                    <Route path="/csv-tool" element={<NetworkList />} />
                                    {/* <Route path="/csv-tool/users" element={<Users />} /> */}
                                    <Route path="/csv-tool/templates" element={<TemplateList />} />
                                    <Route path="/csv-tool/requested-templates" element={<RequestedTemplateList />} />
                                    {/* <Route path="/import-csv" element={<ImportCsv />} /> */}
                                    <Route path="/csv-tool/import-list" element={<ImportList />} />
                                    <Route path="/csv-tool/report" element={<Report />} />
                                    <Route path="/csv-tool/networks" element={<NetworkList />} />
                                    <Route path="/csv-tool/template-types" element={<TemplateTypeList />} />
                                    <Route path="/csv-tool/template-types/:id" element={<TemplateTypeDetails />} />


                                    {/* ADMIN ROUTES */}
                                    <Route path="/admin" element={<Users />} />
                                    {/* SUBSCRIBERS ROUTES */}
                                    <Route path="/subscribers" element={<Subscribers />} />
                                    {/* IBV ROUTES */}
                                    <Route path="/ibv-account-verification" element={<IbvAccountVerification />} />
                                    {/* Appointment ROUTES */}
                                    <Route path="/scheduled-appointments" element={<Appointments />} />
                                    {/* TOOLS ROUTES */}
                                    <Route path="/tools" element={<Tools />} />
                                    <Route path="/tools/convert-pdf-to-csv" element={<ConvertPdfToCsv />} />
                                    {/* Subscriptions */}
                                    <Route path="/subscriptions" element={<Subscriptions />} />
                                    {/* Notification Tracker */}
                                    <Route path="/notification_tracker" element={<NotificationTracker />} />
                                </>
                                :
                                <Route path="/" element={<Navigate to="/subscribers-calendly" />} />
                        }
                        {/* Subscriber pending to be activate throght Calendly metting */}
                        <Route path="/subscribers-calendly" element={<SubscribersCalendly />} />

                    </Switch>
                </div>
            </div>
        </>
    );
}

export default AdminUI;